import { TableCell, TableRow, Typography } from '@mui/material';
import JM from 'jalali-moment';
import Label from '../../../components/Label';

// ----------------------------------------------------------------------

export default function GiftListTableRow({ row, rowNumber, selected }) {
  const {
    SubscribePackageGiftCodeLabel,
    SubscribePackageGiftCodeCode,
    SubscribePackageGiftCodeCreatetime,
    SubscribePackageGiftCodeExpireTime,
    SubscribePackageGiftCodeStatus,
  } = row;

  return (
    <TableRow hover selected={selected}>
      <TableCell align="center">
        <Typography variant="body2">{rowNumber}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{SubscribePackageGiftCodeLabel}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{SubscribePackageGiftCodeCode}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{JM(SubscribePackageGiftCodeCreatetime).locale('fa').format('YYYY/MM/DD')}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body2">{JM(SubscribePackageGiftCodeExpireTime).locale('fa').format('YYYY/MM/DD')}</Typography>
      </TableCell>

      <TableCell align="center">
        <Label
          variant={'ghost'}
          color={SubscribePackageGiftCodeStatus == 1 ? 'success' : SubscribePackageGiftCodeStatus == 2 ? 'warning' : 'error'}
          sx={{ textTransform: 'capitalize' }}
        >
          {SubscribePackageGiftCodeStatus == 1
            ? 'فعال'
            : SubscribePackageGiftCodeStatus == 2
            ? 'مصرف شده'
            : SubscribePackageGiftCodeStatus == 3
            ? 'منقضی شده'
            : '-'}
          {(!SubscribePackageGiftCodeStatus && 'غیر فعال') || ''}
        </Label>
      </TableCell>
    </TableRow>
  );
}
